import { Box } from "@mui/material";
import LogoLight from "assets/images/logo_xplore_bianco.png";
import LogoDark from "assets/images/logo_xplore.png";
import {useTheme} from "@mui/material/styles";

const Logo = () => {
    const theme = useTheme();
    return (<Box sx={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <img alt="Logo" src={theme.palette.mode === 'dark' ? LogoLight : LogoDark} width={100} />
    </Box>)
};

export default Logo;
